module.exports = __webpack_public_path__ + "media/images/application2/AppEvents__hero__socials__a--twitter-c03de033a81b7963e9dee8f399f37e07.svg";